exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-iframe[data-v-3a3da276] {\n   position: relative;\n   width: 100%;\n   overflow: scroll;\n   padding-bottom: 20%;\n}\n.container-iframe iframe[data-v-3a3da276] {\n   width: 100%;\n}\n.iframe[data-v-3a3da276] {\n   position: absolute;\n   width: 100%;\n   top: 0;\n   left: 0;\n}\n", ""]);

// exports
